<template>
    <div id="main" class="select-modal">
        <div class="page">
            <div class="aparelhos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('controle-aparelhos') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('colaborador') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('controle-aparelhos') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons"></div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <!-- PESQUISA -->
                        <div class="column header-search is-6">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-aparelho"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-5">
                            <label v-text="$t('situacao')" />
                            <vss-select
                                ref="situacaoInput"
                                class="smaller no-clear"
                                label="label"
                                v-model="situacao"
                                :options="situacoes"
                                @input="onSituacaoChanged"
                                :height="40"
                            >
                                <template #multiple-selected="{ selected }">
                                    ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                                </template>
                            </vss-select>
                        </div>
                        <div class="column is-2" v-if="exportacaoTipo && permissao.export">
                            <div class="mt-2-custom">
                                <div class="data-exporta" v-if="exportacaoTipo.exportapdf == 1">
                                    <b-button 
                                        type="is-primary" 
                                        icon-right="file-pdf" 
                                        @click="checkExport('pdf')"
                                        v-tippy 
                                        :title="$t('msg-tooltip-pdf')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="aparelhos-table registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="aparelhos && !aparelhos.length" />
                    <b-table
                        v-else
                        class="data-table"
                        :data="aparelhos ? aparelhos : []"
                        backend-sorting
                        backend-pagination
                        @sort="updateSort"
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.label != '' ? $t(f.label) : ''"
                            :sortable="f.sortable"
                            :width="f.width"
                            :centered="f.centered"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <!-- BOTÕES DE ACÃO ATIVAR/INATIVAR -->
                            <div v-if="f.key == 'acao'" style="text-align: center">
                                <div v-if="props.row.situacao == 'I'">
                                    <b-button
                                        v-if="permissao.update"
                                        type="is-success"
                                        @click="() => openModalAparelhos(props.row, 'A')"
                                        icon-right="check"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('ativar')"
                                    />
                                </div>
                                <div v-else>
                                    <b-button
                                        v-if="permissao.delete"
                                        type="is-danger"
                                        @click="() => openModalAparelhos(props.row, 'I')"
                                        icon-right="delete"
                                        position="is-left"
                                        v-tippy 
                                        :title="$t('inativar')"
                                    />
                                </div>
                            </div>

                            <!-- COLUNA DATA DE INCLUSÃO -->
                            <div v-else-if="f.key == 'dataAtivacao' || f.key == 'dataInativacao'">
                                {{
                                    props.row[f.key]
                                        ? $moment(props.row[f.key]).format('L')
                                        : '—'
                                }}
                            </div>
                            <!-- COLUNA IMEI -->
                            <div v-else-if="f.key == 'imei'">
                                <span style="font-weight: bold">{{ props.row.imei }}</span>
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <b-modal :active.sync="isAparelhosSelectOpen">
                        <AparelhosModal
                            @ativacaoInativacao="ativacaoInativacao"
                            @fecharModal="closeModal"
                            :aparelho="aparelho"
                            :tipo="tipo"
                            :isAparelhoJupiter="true"
                        />
                    </b-modal>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AparelhoJupiterService from '@/services/AparelhoJupiterService';
import MMChaveLiberacaoService from '@/services/MMChaveLiberacaoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import AparelhosModal from '@/components/colaborador/AparelhosModal';
import ExportacaoTipoService from "@/services/ExportacaoTipoService";
import ExportacaoDadosService from "@/services/ExportacaoDadosService";
import ExportacaoService from "@/services/ExportacaoService";

export default {
    components: {
        ContainerLoader,
        AparelhosModal,
    },
    data() {
        return {
            ipaddress: '',
            updateThis: {},
            aparelhos: [],
            service_mm: new MMChaveLiberacaoService(this.$http, this.$router),
            service: new AparelhoJupiterService(this.$http, this.$router),
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),

            fields: [
                { key: 'imei', label: 'imei', sortable: true, width: 450 },
                {
                    key: 'dataAtivacao',
                    label: 'data-ativacao-reduzida',
                    sortable: false,
                    width: 150,
                    centered: true,
                    vcenter: true,
                },
                {
                    key: 'usuarioAtivacao',
                    label: 'usuario-ativacao',
                    sortable: false,
                    width: 200,
                    centered: true,
                    vcenter: true,
                    sortFn: null,
                },
                {
                    key: 'dataInativacao',
                    label: 'data-inativacao',
                    sortable: false,
                    width: 200,
                    centered: true,
                    vcenter: true,
                    sortFn: null,
                },
                {
                    key: 'usuarioInativacao',
                    label: 'usuario-inativacao',
                    sortable: false,
                    width: 200,
                    centered: true,
                    vcenter: true,
                    sortFn: null,
                },
                {
                    key: 'acao',
                    label: 'acao',
                    sortable: false,
                    width: 50,
                    centered: true,
                    sortFn: null,
                },
            ],
            situacao: { label: 'todos', id: 2 },
            situacoes: [
                { label: 'todos', id: 2 },
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 3 },
            ],
            order: 'desc',
            column: 'datahorainc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isAparelhosSelectOpen: false,
            message: '',
            aparelho: {},
            tipo: null,
            isLoading: false,
            exportacaoTipo: {},
            permissao: {},
            tipoExportacao: null,
            tableExportacao: [],
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess(
            'admin',
            'colaborador-jupiter',
            'usuario-controle-aparelhos-jupiter'
        );
        this.carregaExportacaoTipo();
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'controle-aparelhos-jupiter' },
            });
        } else {
            this.carregarDados();
            this.getIpAdress();
        }
    },
    methods: {
        carregaExportacaoTipo() {
            // Indica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela("CONTROLEAPARELHOS").then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.$store.state.user.idClienteSovis,
                    currentPage - 1,
                    this.order,
                    this.column,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.query
                )
                .then(this.mapItems)
                .then((r) => {
                    this.aparelhos = r;
                    this.isLoading = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar aparelhos.');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            if (body.content) {
                this.pagination.totalRows = body.totalElements;
                return body.content.map(m => {
                    return {
                        id: m.idaparelho,
                        idaparelho: m.idaparelho,
                        imei: m.imei,
                        license_key: m.license_key,
                        login: m.login,
                        nome: m.nome,
                        situacao: m.situacao,
                        vendedor_id: m.vendedor_id,
                        dataAtivacao: m.dataAtivacao,
                        dataInativacao: m.dataInativacao,
                        usuarioAtivacao: m.usuarioAtivacao ? m.usuarioAtivacao : '—' , 
                        usuarioInativacao: m.usuarioInativacao ? m.usuarioInativacao : '—',
                    };
                });
            }
        },
        getIpAdress() {
            fetch('https://api.ipify.org?format=json')
                .then((x) => x.json())
                .then(({ ip }) => {
                    this.ipaddress = ip;
                });
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },

        updateSort(sort, order) {
            this.column = sort;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.query = this.removeAcentos(value);
            this.carregarDados();
        },

        confirmUpdate(item, situacao) {
            this.updateThis = { ...item };
            if (situacao === 1) {
                this.updateThis.situacao = 'A';
                this.updateAparelho(1);
            } else if (situacao === 2) {
                this.updateThis.situacao = 'A';
                this.updateAparelho(2);
            } else if (situacao === 0) {
                this.updateThis.situacao = 'I';
                this.updateAparelho(0);
            }
        },
        // Atualização
        updateAparelho(operacao) {
            this.$store.commit('addLoader');
            // Cria o objeto que sera inserido na tabela mm_chave_liberacao
            let MMChaveLiberacao = {
                cliente_sovis_id: this.$store.state.user.idClienteSovis,
                vendedor_id: this.updateThis.vendedor_id,
                aparelho_id: this.updateThis.id,
                imei: this.updateThis.imei,
                operacao: operacao,
                mm_user_id: 1,
                mm_user_name: this.$store.state.user.nome,
                codigo_chamado: null,
                observacao: null,
                faturar: '',
                faturado: 'N',
                datafaturado: null,
                ip: this.ipaddress,
                macaddress: 'AAAA:BBBB:CCCC:DDDD',
                license_key: this.updateThis.license_key,
                aparelho_inativado_id: '0',
                id_fvw_usuarios: this.$store.state.user.id,
            };

            let aparelho = {
                idaparelho: this.updateThis.id,
                imei: this.updateThis.imei,
                situacao: this.updateThis.situacao,
                chaveLiberacao: MMChaveLiberacao,
            };

            this.service
                .updateSituacaoAparelhos(aparelho)
                .then((r) => {
                    if (r.status == 200){
                        this.$root.showMessage('success', 'msg-reativou-aparelho');
                    } else {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');    
                    }
                })
                .catch((e) => {
                    console.error('Erro ao alterar a situação.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                    this.closeModal();
                    this.carregarDados();
                });
        },
        removePrompt() {
            this.updateThis = null;
        },
        // @71530 - ADICIONADO MODAL PARA OPERAÇÕES DE ATIVAÇÃO/INATIVAÇÃO
        openModalAparelhos(props, tipo) {
            this.isAparelhosSelectOpen = true;
            if (tipo === 'A') {
                this.tipo = 1;
            } else {
                this.tipo = 0;
            }
            this.aparelho = props;
        },
        closeModal() {
            this.isAparelhosSelectOpen = !this.isAparelhosSelectOpen;
        },
        ativacaoInativacao(imeiObj) {
            // @71530 - OPERAÇÃO 2: TROCA // OPERAÇÃO 1: ADIÇÃO // OPERAÇÃO 0: DESATIVAÇÃO
            // @71530 -
            if (imeiObj.imeiDesativacao) {
                this.confirmUpdate(imeiObj.imeiOperacao, 2);
                this.confirmUpdate(imeiObj.imeiDesativacao, 0);
            } else {
                if (imeiObj.operacao == 'A') {
                    this.confirmUpdate(imeiObj.imeiOperacao, 1);
                } else {
                    this.confirmUpdate(imeiObj.imeiOperacao, 0);
                }
            }
        },
        checkExport(tipo) {
            if (this.aparelhos.length > 0){
                this.tipoExportacao = tipo;

                this.gerarArquivoExportacao();
            }else {
                this.$root.showMessage("alert", "msg-valida-tabela");
            }
        },
        gerarArquivoExportacao() {
            this.isLoading = true;

            this.service
                .findAll(
                    this.$store.state.user.idClienteSovis,
                    0,
                    this.order,
                    this.column,
                    1000,
                    this.situacao.id,
                    this.query
                )
            .then( value => {
                if(value.content){
                    this.exportacao(value.content);
                }
            })
            .catch(error => {
                console.error('Erro ao trazer dados de itens.', error);
                this.$root.showMessage('error', 'msg-erro-exp-gerar');
            })
            .finally((_) => {
                this.isLoading = false;
            });
        },
        exportacao(content) {
            this.isLoading = true;
            
            this.tableExportacao = content;

            this.tableExportacao.forEach((table) => {
                table.dataacessoExporta = table.dataacesso ? this.$moment(table.dataacesso).format('DD/MM/YYYY HH:mm:ss') : null;
                table.datainclusaoExporta = this.$moment(table.datainclusao).format('L');
            });

            const exportacao = {
                usuario: {
                    idusuarioerp: this.$store.state.user.idusuarioerp,
                }
            };
            
            let exportacaoControleAparelhos = {
                exportacao: exportacao,
                usuario: this.$store.state.user,
                aparelhos: this.tableExportacao,
            };

            this.exportacaoDadosService
                .saveControleAparelhos(
                    exportacaoControleAparelhos,
                    this.tipoExportacao,
                )
                .then(({content}) => {
                    this.getArchive(content);
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                }).finally((_) => {
                    this.isLoading = false;
                });
        },
        getArchive(url) {
            this.isLoading = true;

            this.exportacaoService.downloadArchive(url)
            .then((r) => {
                const prefix = this.tipoExportacao === "pdf" ? 'application' : 'text'

                const blob = new Blob([r.data], { type: `${prefix}/${this.tipoExportacao}` });

                const fileURL = window.URL.createObjectURL(blob);

                window.open(fileURL, '_blank');

                window.URL.revokeObjectURL(blob);
            })
            .catch((e) => {
                this.$root.showMessage('error', 'msg-erro-exp-gerar');
            })
            .finally((_) => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    h1.title {
        padding-top: 0px;
        margin-bottom: 0 !important;
    }
    .tag {
        height: 35px;
        width: 120px;
    }

    .page {
        position: relative;
        padding-left: 0;

        .control-bar {
            margin-bottom: 0;

            .column:first-child {
                padding-bottom: 0.25rem;
            }

            .column:last-child {
                padding-top: 0.25rem;
            }

            .date-opts {
                margin-bottom: 0.5rem !important;
            }

            .date-group {
                justify-content: center;
                flex-wrap: wrap;
            }

            .periodo-custom {
                width: 100%;
                justify-content: center;
                align-items: center;

                .periodo-input {
                    margin: 0 1rem;
                    padding: 0.2rem;
                    height: 27px;
                    width: 100px;
                    font-size: 0.75rem;
                }
            }

            button.btn-search {
                height: 27px;
                font-size: 12px;
                color: $sovis-white;
                @include gradient-button();
            }
        }

        td.strike > div:not(.no-strike) {
            text-decoration: line-through;
        }

        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }

        .sub-text {
            text-transform: uppercase;
            font-size: 12px;
        }
    }
}
.data-exporta {
    padding: 0 4px 0 0;
}
.mt-2-custom {
    display: flex;
    padding: 23px 0 0 0;
}
.filtro-header {
    display: flex;
    align-items: center;
}
.export-opcoes {
    .modal {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: 40% !important;
    }
    .modal-card {
        width: auto !important;
    }
    .titulo-input {
        width: 100%;
    }
    .form-buttons2 {
        top: 20px;
        display: flex;
        margin: 0 auto;

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 47px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
    .ok {
        margin: 0;
    }
}
.search-and-filter {
    padding-bottom: 20px;
}
@media screen and (max-width: 1024px) {
    .header-search {
        width: 100%;
    }
    .column {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        width: 100%;
    }
    .mt-2-custom {
        margin-top: 0;
        padding: 0;
        justify-content: center;
    }
}
</style>
